import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Divider, DialogActions, MenuItem, Card, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../../components/elements/fields/RayaField";
import {HandCoins, RefreshCcw} from "lucide-react";
import SubTitle from "../../../../components/elements/SubTitle";
import {
    calcStockPrice,
    currencySymbol,
    price, truncate
} from "../../../../../config/values";
import UserChooser from "../../../../components/elements/fields/UserChooser";
import NumberField from "../../../../components/elements/fields/NumberField";
import {useIsSmall} from "../../../../../config/hooks/useWindowDimensions";
import {isUser} from "../../../../../config/Permissions";

const ProfitStocks = ({ classes,profit }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();
    const closeDialog = () => {
        setOpen(false);
    }
    console.log(profit)
    return (
        <>
            <Button
                variant="outlined"
                color="secondary"
                onClick={() => setOpen(!open)}
                size="small"
            >
                {t('view')}
            </Button>
            <Dialog
                fullWidth
                maxWidth={'xs'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className='dialog-title'>
                    {t('viewStocks')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={1}>
                        {
                            profit?.ownerships.map((item,index) => (
                                <Grid item size={12} key={index}>
                                    {
                                        !isUser() ?
                                            <div className="flex-space bg-gray-box bg-narrow">
                                                <div className="d-flex" style={{gap:20}}>
                                                    <Typography className='font-12 color-gray-number'>{index + 1}</Typography>
                                                    <Typography className='font-13'>{truncate(item.user?.first_name + " " + item.user?.last_name , 15)}</Typography>
                                                </div>
                                                <Typography className='font-13' >{item.stock?.number} ({price(profit.amount / (!!item.stock?.is_complete ? 1 : 100))} {currencySymbol})</Typography>
                                            </div>
                                            :
                                            <div className="d-flex flex-justify-between bg-gray-box bg-narrow" style={{gap:20}}>
                                                <Typography className='font-12 color-gray-number'>{index + 1}</Typography>
                                                <Typography className='font-13' >{item.stock?.number} ({price(profit.amount / (!!item.stock?.is_complete ? 1 : 100))} {currencySymbol})</Typography>
                                            </div>

                                    }

                                </Grid>
                            ))
                        }
                    </Grid>

                </DialogContent>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(ProfitStocks);
